import api from "../services/api";
import { IPagination } from "../models/IPagination";
import { FawryTransactionDTO, RegistrationPaymentDTO, InstaPayRegistrationDTO } from "../models/IFawryTransaction";
import { BalanceTransactionDTO } from "../models/IBalance";

export const getAllFawryTransactions = (
  pageNumber: number,
  pageSize: number,
  search?: string,
  status?: string,
  purpose?: string,
  method?: string,
  tournamentId?: string,
  tournamentDate?: string,
  sortBy?: string,
  sortOrder?: string
): Promise<{
  data: { items: FawryTransactionDTO[]; pagination: IPagination; totalAmount?: number };
}> => {
  const params: Record<string, any> = { pageNumber, pageSize };
  if (search) params.search = search;
  if (status) params.status = status;
  if (purpose) params.purpose = purpose;
  if (method) params.method = method;
  if (tournamentId) params.tournamentId = tournamentId;
  if (tournamentDate) params.tournamentDate = tournamentDate;
  if (sortBy) params.sortBy = sortBy;
  if (sortOrder) params.sortOrder = sortOrder;
  return api.get("Payment/fawry/transactions", { params });
};

export const getFawryTournaments = (
  onDate?: string
): Promise<{ data: InstaPayTournamentOptionDTO[] }> => {
  const params: Record<string, any> = {};
  if (onDate) params.onDate = onDate;
  return api.get("Payment/fawry/transactions/tournaments", { params });
};

export const getAllRegistrationPayments = (
  pageNumber: number,
  pageSize: number,
  search?: string,
  status?: string,
  method?: string,
  scope?: string,
  tournamentId?: string,
  tournamentDate?: string,
  sortBy?: string,
  sortOrder?: string
): Promise<{
  data: { items: RegistrationPaymentDTO[]; pagination: IPagination };
}> => {
  const params: Record<string, any> = { pageNumber, pageSize };
  if (search) params.search = search;
  if (status) params.status = status;
  if (method) params.method = method;
  if (scope) params.scope = scope;
  if (tournamentId) params.tournamentId = tournamentId;
  if (tournamentDate) params.tournamentDate = tournamentDate;
  if (sortBy) params.sortBy = sortBy;
  if (sortOrder) params.sortOrder = sortOrder;
  return api.get("Payment/registration-payments", { params });
};

export const getRegistrationPaymentTournaments = (
  onDate?: string
): Promise<{ data: InstaPayTournamentOptionDTO[] }> => {
  const params: Record<string, any> = {};
  if (onDate) params.onDate = onDate;
  return api.get("Payment/registration-payments/tournaments", { params });
};

export const getAllInstaPayRegistrations = (
  pageNumber: number,
  pageSize: number,
  search?: string,
  paymentStatus?: string,
  tournamentId?: string,
  tournamentDate?: string,
  sortBy?: string,
  sortOrder?: string,
  purpose?: string
): Promise<{
  data: { items: InstaPayRegistrationDTO[]; pagination: IPagination; totalAmount?: number };
}> => {
  const params: Record<string, any> = { pageNumber, pageSize };
  if (search) params.search = search;
  if (paymentStatus) params.paymentStatus = paymentStatus;
  if (tournamentId) params.tournamentId = tournamentId;
  if (tournamentDate) params.tournamentDate = tournamentDate;
  if (purpose) params.purpose = purpose;
  if (sortBy) params.sortBy = sortBy;
  if (sortOrder) params.sortOrder = sortOrder;
  return api.get("Payment/instapay-registrations", { params });
};

export const confirmInstaPayRegistration = (
  teamMemberId: string
): Promise<{ data: InstaPayRegistrationDTO }> => {
  return api.post(`Payment/instapay-registrations/${teamMemberId}/confirm`);
};

export const rejectInstaPayRegistration = (
  teamMemberId: string
): Promise<{ data: InstaPayRegistrationDTO }> => {
  return api.post(`Payment/instapay-registrations/${teamMemberId}/reject`);
};

export const confirmInstaPayReservation = (
  reservationId: string
): Promise<{ data: InstaPayRegistrationDTO }> => {
  return api.post(`Payment/instapay-reservations/${reservationId}/confirm`);
};

export interface InstaPayTournamentOptionDTO {
  id: string;
  name: string;
  startDate: string;
  endDate: string;
}

export const getInstaPayTournaments = (
  onDate?: string
): Promise<{ data: InstaPayTournamentOptionDTO[] }> => {
  const params: Record<string, any> = {};
  if (onDate) params.onDate = onDate;
  return api.get("Payment/instapay-registrations/tournaments", { params });
};

export const getAllBalanceTransactions = (
  pageNumber: number,
  pageSize: number,
  search?: string,
  status?: string,
  type?: string,
  sortBy?: string,
  sortOrder?: string
): Promise<{
  data: { items: BalanceTransactionDTO[]; pagination: IPagination };
}> => {
  const params: Record<string, any> = { pageNumber, pageSize };
  if (search) params.search = search;
  if (status) params.status = status;
  if (type) params.type = type;
  if (sortBy) params.sortBy = sortBy;
  if (sortOrder) params.sortOrder = sortOrder;
  return api.get("Balance/transactions/all", { params });
};
